import { createRootRoute, Outlet } from "@tanstack/react-router";
import { type ComponentType, Suspense, useEffect, useState } from "react";
import { AppErrorBoundary } from "@/components/AppErrorBoundary";
import { Spinner } from "@/components/ui/spinner";
import { AppDataProvider } from "../components/providers/AppDataProvider";

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <AppDataProvider>
      <AppErrorBoundary title="The application encountered an error">
        <Suspense
          fallback={
            <div className="flex min-h-svh flex-col items-center justify-center">
              <Spinner size={32} />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </AppErrorBoundary>
      <AgentationMount />
    </AppDataProvider>
  );
}

function AgentationMount() {
  const [AgentationComponent, setAgentationComponent] = useState<ComponentType | null>(null);

  useEffect(() => {
    if (!import.meta.env.DEV) {
      return;
    }

    let isMounted = true;

    void import("agentation").then((module) => {
      if (isMounted) {
        setAgentationComponent(() => module.Agentation);
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  if (!import.meta.env.DEV || !AgentationComponent) {
    return null;
  }

  return <AgentationComponent />;
}
